import styled from 'styled-components'

const KasKrsStyle = styled.div`
  display: grid;
  grid-template-columns: 200px 184px 160px;
  align-items: start;

  .radio {
    grid-column: 1/2;
  }

  .radioGroup {
    height: 16px;
    margin-bottom: 7px;
  }

  .text {
    grid-column: 2/3;
    > div {
      margin: 7px 0 0 0;
    }
  }

  .caption {
    font-size: 11px;
    line-height: 1.45;
    letter-spacing: 0.4px;
    color: ${props => props.theme.black38};
  }

  .buttonGUS {
    margin-top: 18px;
    margin-left: 16px;
  }
`
export default KasKrsStyle
